<template>
  <div>
    <v-btn
      outline primary
      :block="block"
      @click.native.stop="onClick"
      ref="fileTextField"
      :loading="loading">
      <v-icon class="primary--text mr-2">attach_file</v-icon>
      {{ config.label }}
    </v-btn>
    <input
      type="file"
      :accept="accept"
      @change="onFileChange"
      ref="fileInput">
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Upload from '@/api/upload'
  import input from '@/mixins/input'
  export default {
    mixins: [input],
    props: {
      accept: {
        type: String,
        default: '*'
      },
      block: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        loading: false
      }
    },
    computed: mapGetters({
      platform: 'skiliko/session/currentPlatform'
    }),
    methods: {
      onClick () {
        this.$refs.fileInput.click()
      },
      onFileChange ($event) {
        const files = $event.target.files || $event.dataTransfer.files
        this.loading = true
        Upload.send({
          file: files[0],
          platform: this.platform,
          path: this.config.path
        })
          .then(({ data }) => {
            this.loading = false
            this.$emit('input', data.url)
          })
          .catch(_ => (this.loading = false))
      }
    }
  }
</script>

<style scoped>
  input[type="file"] {
    position: absolute;
    left: -99999px;
  }
</style>



// WEBPACK FOOTER //
// src/components/inputs/File.vue